import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

// images
import icon_back_screen from "assets/icon_back_screen.svg";

const PageTitle = (props) => {
  const {
    className,
    title,
    rightComponent,
    leftIcon,
    onClickLeftIcon,
    hideLeftIcon = false,
  } = props;
  const navigate = useNavigate();

  return (
    <div className={className}>
      <div className="w-1/4">
        <img
          src={leftIcon || icon_back_screen}
          alt="icon dot"
          style={hideLeftIcon ? { visibility: "hidden" } : undefined}
          onClick={() => {
            onClickLeftIcon ? onClickLeftIcon() : navigate(-1);
          }}
        />
      </div>
      <div className="font-700 fs-16">{title}</div>
      <div className="w-1/4 flex justify-end">{rightComponent || ""}</div>
    </div>
  );
};

export default styled(PageTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(env(safe-area-inset-top, 0px) + 10px) 16px 8px;
`;
